import { RotateCw } from '@orgus/ui/icons';
import { IconButton } from '@orgus/ui';
import { isInstalledApp } from '../../lib/installedApp.ts';

/** Load the page again: the installed app's window has no reload button of its own. */
export function reloadPage(): void {
  window.location.reload();
}

/**
 * The reload button, shown only in the installed app (a browser tab has its own). The tooltip
 * teaches Ctrl R, which reloads the app window too.
 */
export function ReloadButton({ size }: { size?: 'sm' | 'md' }) {
  if (!isInstalledApp()) return null;
  return <IconButton label="Reload page" icon={<RotateCw />} shortcut={['mod', 'r']} size={size} onClick={reloadPage} />;
}
